"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClayDropDownWithItems = void 0;
var _shared = require("@clayui/shared");
var _react = _interopRequireWildcard(require("react"));
var _Caption = _interopRequireDefault(require("./Caption"));
var _DropDown = _interopRequireDefault(require("./DropDown"));
var _DropDownWithDrilldown = require("./DropDownWithDrilldown");
var _Help = _interopRequireDefault(require("./Help"));
var _Items = require("./Items");
var _Search = _interopRequireDefault(require("./Search"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var counter = 0;
function getId() {
  return "id-".concat(counter++);
}
var transformTreeToLinkedList = function transformTreeToLinkedList(items, id) {
  var menu = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  menu[id] = [];
  items === null || items === void 0 ? void 0 : items.forEach(function (item, index) {
    var keys = Object.keys(item);
    menu[id][index] = {};
    keys.forEach(function (key) {
      if (item['type'] === 'contextual' && Array.isArray(item[key])) {
        var childId = getId();
        menu[id][index].child = childId;
        transformTreeToLinkedList(item[key], childId, menu);
      } else {
        if (item[key] === 'contextual') {
          menu[id][index].type = 'item';
        } else {
          menu[id][index][key] = item[key];
        }
      }
    });
  });
  return menu;
};
var ClayDropDownWithItems = exports.ClayDropDownWithItems = function ClayDropDownWithItems(_ref) {
  var active = _ref.active,
    alignmentByViewport = _ref.alignmentByViewport,
    alignmentPosition = _ref.alignmentPosition,
    caption = _ref.caption,
    className = _ref.className,
    closeOnClickOutside = _ref.closeOnClickOutside,
    containerElement = _ref.containerElement,
    _ref$defaultActive = _ref.defaultActive,
    defaultActive = _ref$defaultActive === void 0 ? false : _ref$defaultActive,
    footerContent = _ref.footerContent,
    helpText = _ref.helpText,
    items = _ref.items,
    menuElementAttrs = _ref.menuElementAttrs,
    menuHeight = _ref.menuHeight,
    menuWidth = _ref.menuWidth,
    offsetFn = _ref.offsetFn,
    onActiveChange = _ref.onActiveChange,
    _ref$onSearchValueCha = _ref.onSearchValueChange,
    onSearchValueChange = _ref$onSearchValueCha === void 0 ? function () {} : _ref$onSearchValueCha,
    renderMenuOnClick = _ref.renderMenuOnClick,
    searchable = _ref.searchable,
    searchProps = _ref.searchProps,
    _ref$searchValue = _ref.searchValue,
    searchValue = _ref$searchValue === void 0 ? '' : _ref$searchValue,
    _ref$triggerIcon = _ref.triggerIcon,
    triggerIcon = _ref$triggerIcon === void 0 ? null : _ref$triggerIcon,
    spritemap = _ref.spritemap,
    trigger = _ref.trigger;
  var triggerElementRef = (0, _react.useRef)(null);
  var _useControlledState = (0, _shared.useControlledState)({
      defaultName: 'defaultActive',
      defaultValue: defaultActive,
      handleName: 'onActiveChange',
      name: 'active',
      onChange: onActiveChange,
      value: active
    }),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    internalActive = _useControlledState2[0],
    setInternalActive = _useControlledState2[1];
  var hasRightSymbols = (0, _react.useMemo)(function () {
    return !!(0, _Items.findNested)(items, 'symbolRight');
  }, [items]);
  var hasLeftSymbols = (0, _react.useMemo)(function () {
    return !!(0, _Items.findNested)(items, 'symbolLeft');
  }, [items]);
  var hasContextual = (0, _react.useMemo)(function () {
    return items.some(function (item) {
      return item.type === 'contextual';
    });
  }, [items]);
  var Wrap = footerContent ? 'form' : _react.default.Fragment;
  var isMobile = (0, _shared.useIsMobileDevice)();
  var activeMenu = (0, _react.useMemo)(function () {
    return getId();
  }, []);
  var linkedList = (0, _react.useMemo)(function () {
    if (isMobile && hasContextual) {
      return transformTreeToLinkedList(items, activeMenu);
    }
  }, [items, hasContextual, isMobile]);
  if (hasContextual && isMobile) {
    return /*#__PURE__*/_react.default.createElement(_DropDownWithDrilldown.ClayDropDownWithDrilldown, {
      active: internalActive,
      alignmentByViewport: alignmentByViewport,
      alignmentPosition: alignmentPosition,
      caption: caption,
      className: className,
      containerElement: containerElement,
      defaultActiveMenu: activeMenu,
      footerContent: footerContent,
      helpText: helpText,
      menuElementAttrs: menuElementAttrs,
      menuHeight: menuHeight,
      menuWidth: menuWidth,
      menus: linkedList,
      offsetFn: offsetFn,
      onActiveChange: setInternalActive,
      onSearchValueChange: onSearchValueChange,
      renderMenuOnClick: renderMenuOnClick,
      searchProps: searchProps,
      searchValue: searchValue,
      searchable: searchable,
      trigger: trigger,
      triggerIcon: triggerIcon
    });
  } else {
    return /*#__PURE__*/_react.default.createElement(_DropDown.default, {
      active: internalActive,
      alignmentByViewport: alignmentByViewport,
      alignmentPosition: alignmentPosition,
      className: className,
      closeOnClickOutside: closeOnClickOutside,
      containerElement: containerElement,
      hasLeftSymbols: hasLeftSymbols,
      hasRightSymbols: hasRightSymbols,
      menuElementAttrs: menuElementAttrs,
      menuHeight: menuHeight,
      menuWidth: menuWidth,
      offsetFn: offsetFn,
      onActiveChange: setInternalActive,
      renderMenuOnClick: renderMenuOnClick,
      trigger: /*#__PURE__*/_react.default.cloneElement(trigger, {
        ref: function ref(node) {
          if (node) {
            triggerElementRef.current = node;
            // Call the original ref, if any.
            var ref = trigger.ref;
            if (typeof ref === 'function') {
              ref(node);
            }
          }
        }
      }),
      triggerIcon: triggerIcon
    }, /*#__PURE__*/_react.default.createElement(_Items.ClayDropDownContext.Provider, {
      value: {
        close: function close() {
          var _triggerElementRef$cu;
          setInternalActive(false);
          (_triggerElementRef$cu = triggerElementRef.current) === null || _triggerElementRef$cu === void 0 ? void 0 : _triggerElementRef$cu.focus();
        }
      }
    }, helpText && /*#__PURE__*/_react.default.createElement(_Help.default, null, helpText), searchable && /*#__PURE__*/_react.default.createElement(_Search.default, _extends({}, searchProps, {
      onChange: onSearchValueChange,
      spritemap: spritemap,
      value: searchValue
    })), /*#__PURE__*/_react.default.createElement(Wrap, null, footerContent ? /*#__PURE__*/_react.default.createElement("div", {
      className: "inline-scroller"
    }, /*#__PURE__*/_react.default.createElement(_Items.DropDownItems, {
      items: items,
      spritemap: spritemap
    })) : /*#__PURE__*/_react.default.createElement(_Items.DropDownItems, {
      items: items,
      spritemap: spritemap
    }), caption && /*#__PURE__*/_react.default.createElement(_Caption.default, null, caption), footerContent && /*#__PURE__*/_react.default.createElement("div", {
      className: "dropdown-section",
      role: "presentation"
    }, footerContent))));
  }
};
ClayDropDownWithItems.displayName = 'ClayDropDownWithItems';